import React, { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom';
import watsIcon from '../assest/home/5357b4eb16238760df0ba166628f1cee41086e44.png';
import styleCompanys from '../css/backgrounds/comCreated.module.css'
import '../css/AllServices.css';
function CompanyCreated() {
    const serviceRefs = useRef([]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate-in');
                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                threshold: 0.1,
                rootMargin: '0px 0px -50px 0px'
            }
        );

        serviceRefs.current.forEach((ref) => {
            if (ref) observer.observe(ref);
        });

        return () => {
            serviceRefs.current.forEach((ref) => {
                if (ref) observer.unobserve(ref);
            });
        };
    }, []);

    const addToRefs = (el, index) => {
        if (el && !serviceRefs.current.includes(el)) {
            serviceRefs.current[index] = el;
        }
    };

    return (
        <>
            <head style={{all:'initial'}}>
                <title>كيف أسس شركة صغيرة في السعودية</title>
                <meta name="description" content="كيف أسس شركة صغيرة في السعودية" />
                <meta name="keywords" content="كيف أسس شركة صغيرة في السعودية , شركات تأسيس أعمال في جدة" />
            </head>
            <div className="services-name">
                <div className={`${styleCompanys.back1} service-item`} ref={(el) => addToRefs(el, 0)}>
                    <h1>الترخيص المهني</h1>
                    <div>
                        <span><Link to='/services/professionallicense'>التفاصيل</Link></span>
                        <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                            <Link to='https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص مهني'>أطلب الان</Link>
                        </span>
                    </div>
                </div>
                <div className={`${styleCompanys.back2} service-item`} ref={(el) => addToRefs(el, 1)}>
                    <h1>الترخيص الزراعي</h1>
                    <div>
                        <span><Link to='/services/agriculturallicense'>التفاصيل</Link></span>
                        <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                            <Link to='https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص زراعي'>أطلب الان</Link>
                        </span>
                    </div>
                </div>
                <div className={`${styleCompanys.back3} service-item`} ref={(el) => addToRefs(el, 2)}>
                    <h1>ترخيص تجاري اجنبي</h1>
                    <div>
                        <span><Link to='/services/forecommlice'>التفاصيل</Link></span>
                        <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                            <Link to='https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص تجاري اجنبي'>أطلب الان</Link>
                        </span>
                    </div>
                </div>
                <div className={`${styleCompanys.back4} service-item`} ref={(el) => addToRefs(el, 3)}>
                    <h1>ترخيص تجاري بشريك سعودي</h1>
                    <div>
                        <span><Link to='/services/coiLissauPar'>التفاصيل</Link></span>
                        <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                            <Link to='https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص تجاري بشريك سعودي'>أطلب الان</Link>
                        </span>
                    </div>
                </div>
                <div className={`${styleCompanys.back5} service-item`} ref={(el) => addToRefs(el, 4)}>
                    <h1>الترخيص المهني بشريك سعودي</h1>
                    <div>
                        <span><Link to='/services/proflicesapartner'>التفاصيل</Link></span>
                        <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                            <Link to='https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص مهني بشريك سعودي'>أطلب الان</Link>
                        </span>
                    </div>
                </div>
                <div className={`${styleCompanys.back6} service-item`} ref={(el) => addToRefs(el, 5)}>
                    <h1>ترخيص أنشطة النقل</h1>
                    <div>
                        <span><Link to='/services/transactivlice'>التفاصيل</Link></span>
                        <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                            <Link to='https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص نشاط نقل'>أطلب الان</Link>
                        </span>
                    </div>
                </div>
                <div className={`${styleCompanys.back7} service-item`} ref={(el) => addToRefs(el, 6)}>
                    <h1>الترخيص العقاري</h1>
                    <div>
                        <span><Link to='/services/prolic'>التفاصيل</Link></span>
                        <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                            <Link to='https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص عقاري'>أطلب الان</Link>
                        </span>
                    </div>
                </div>
                <div className={`${styleCompanys.back8} service-item`} ref={(el) => addToRefs(el, 7)}>
                    <h1>ترخيص صناعي</h1>
                    <div>
                        <span><Link to='/services/indlic'>التفاصيل</Link></span>
                        <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                            <Link to='https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص صناعي'>أطلب الان</Link>
                        </span>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CompanyCreated